import styled from 'styled-components';

export const FlexBox = styled.div`
  display: flex;
  margin: ${({ margin }) => margin};
  padding: ${({ padding }) => padding};
  background: ${({ bg, theme }) => (bg === 'theme' ? theme.boxbg : '')};
  height: ${({ height }) => height};

  flex-direction: ${({ direction }) => direction};
  justify-content: ${({ justify }) => justify};
  align-content: ${({ content }) => content};
  align-items: ${({ align }) => align};

  flex: ${({ flex }) => flex};
  flex-basis: ${({ basis }) => basis};
  flex-wrap: ${({ wrap }) => wrap || 'wrap'};
`;

export const BorderedFlexBox = styled(FlexBox)`
  border: 1px solid ${({ theme }) => theme.border || '#eee'};
  height: ${({ height }) => height};
  padding: 0;
  margin: ${({ margin }) => margin || '5px'};
  user-select: none;
`;

export default FlexBox;
